import React, { useRef, useState } from "react";

export default function ProjectCard3D({ title, image }) {
  const cardRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [rotateX, setRotateX] = useState(0);
  const [rotateY, setRotateY] = useState(0);

  const handleMouseMove = (e) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    const rotX = ((mouseY - centerY) / centerY) * 10;
    const rotY = ((mouseX - centerX) / centerX) * -10;
    setRotateX(rotX);
    setRotateY(rotY);
  };

  const handleMouseLeave = () => {
    setRotateX(0);
    setRotateY(0);
    setIsHovered(false);
  };

  return (
    <div
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={handleMouseLeave}
      style={{
        height: 230,
        borderRadius: "12px 12px 0 0",
        overflow: "hidden",
        cursor: "pointer",
        perspective: "1000px",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          transform: `rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${isHovered ? 1.03 : 1})`,
          transformStyle: "preserve-3d",
          transition: isHovered ? "none" : "transform 600ms cubic-bezier(0.22,1,0.36,1)",
          position: "relative",
        }}
      >
        <img
          src={image}
          alt={title}
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          onError={(e) => {
            e.target.src = "/project-management-team.png";
          }}
        />

        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to top, rgba(10,10,10,0.7), transparent)",
          }}
        />

        <div style={{ position: "absolute", left: 16, right: 16, bottom: 16 }}>
          <h3 style={{ margin: 0, color: "#fff", fontSize: 20 }}>{title}</h3>
        </div>

        <div
          style={{
            position: "absolute",
            inset: 0,
            opacity: isHovered ? 0.15 : 0,
            background: "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.08) 50%, transparent 70%)",
            pointerEvents: "none",
          }}
        />
      </div>
    </div>
  );
}
